export const signUpSignIn = {
    signUp: '注册',
    inputPhone: '请输入手机号码',
    inputCorrectPhoneNumber: '请输入正确的手机号码',
    inputCode: '请输入验证码',
    getCode: '获取验证码',
    countSignIn: '账号登陆',
    codeSignIn: '验证码登陆',
    readAndAccept: '阅读并接受',
    pleaseReadAndAccept: '请先阅读并接受',
    userServicesAgreement: '《用户服务协议》',
    and: '及',
    registerSuccess: '注册成功，请登陆',
    privacyPolicy: '《FoxitHD隐私政策》',
    hasCountPlease: '已有账号，请',
    signIn: '登录',
    interval: '{count}秒后重新发送',
    phoneNumber: '手机号码',
    notHas: '还没有账号，请',
    password: '密码',
    forget: '忘记密码',
    code: '验证码',
    inputUsername: '请输入手机号/邮箱',
    usernameWrong: '请输入正确的手机号/邮箱',
    checkSpace: '密码不能包含空格',
    passwordInconsistent: '两次输入密码不一致',
    notContainChineseError: '密码不能包含中文',
    min: '密码最少8个字符',
    max: '密码最多16个字符',
    passLowError: '密码强度弱, 数字，字母，特殊字符任意两种组合',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    deleteSuccess: '删除成功',
    setPassword: '设置密码',
    enterPassword: '输入密码',
    reEnterPassword: '再次输入密码',
    accountNumber: '账号',
    imageCode: '图形验证码',
    inputImageCode: '请输入图形验证码',
    rememberLoginStatus: '记住登录状态',
    logoutPrompt: '退出登录提示',
    isLoginTip:
        '系统检测到该账号已在其他设备登录，强制登录会导致正在编辑的云端工程不能自动保存至云端，是否继续登录？',
    LogInAgain: '重新登录',
    modelCollocation: '模型搭配',
    modelPackage: '模型包',
    modelSubject: '模型专题',
    brandModelPackage: '品牌模型包',
    dataCount: '{dataCount}个',
    modelCount: '{modelCount}个模型',
    notBusinessHas: '还没有企业账号，',
    applyFreeTrial: '申请免费试用',
    freeUse: '免费试用',
    personalEdition: '尊享版',
    enterpriseEdition: '企业版',
    enterBusinessName: '请输入您所在的企业名称',
    enterName: '请输入您的姓名',
    selectPosition: '请选择您的职务',
    enterPhoneNumber: '请输入您的手机号码',
    enterBusinessNameErrorMsg: '大于2个字、不得输入数字及特殊字符',
    enterNameErrorMsg: '仅可输入中英文，不超过12字符',
    applyTrialMsg: '信息提交后，我们会在7个工作日内与您联系',
    organizationSelect: '选择组织',
    loginSuccess: '登入成功',
    boss: '老板/总监/经理',
    projectManager: '项目经理/工长',
    salesPersonnel: '销售/店长/导购/个体经营',
    student: '学生/业主',
    personalPreference: '个人爱好',
    passwordCannotContainChineseSpaces: '密码不能包含中文和空格',
    weakCryptographicStrength: '密码强度弱, 数字，字母，特殊字符任意两种组合',
    pleaseEnterPasswordAgain: '请再次输入密码',
    pleaseSelectProtocolFirst: '请先勾选协议',
    loginSuccessfully: '登录成功',
    pleaseEnterMobile: '请输入有效的手机号码',
    verificationCodeError: '验证码错误',
    sendVerificationCode: '发送验证码',
    SendInSecond: '{num}秒后发送',
    readAgree: '我已阅读并同意',
    andH: '和',
    enterBusinesses: '你可进入以下企业',
    boundAccount:
        '{phone}已在以下企业或组织绑定了账号，你可进入以下任一企业或组织',
    personalEditionS: '个人版',
    spreadEnterprise: '展开其他{num}个企业',
};
